import React from "react";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import CloseIcon from "@material-ui/icons/Close";
import { IconButton } from "@material-ui/core";

/**
 * Banner pemberitahuan akhir pengembangan SIMRS V1.
 *
 * Ditempatkan sebagai strip tipis pada alur dokumen normal (bukan fixed/overlay)
 * di atas header, sehingga konten di bawahnya hanya tergeser dan tidak pernah
 * tertutup. Banner dapat ditutup oleh user, namun akan tampil kembali setiap
 * halaman di-refresh (state sengaja tidak disimpan).
 */
function WrapperDeprecationBanner() {
  const [show, setShow] = React.useState(true);

  if (!show) return null;

  return (
    <div className='deprecation-banner' role='status'>
      <InfoOutlinedIcon className='deprecation-banner-icon' />
      <p className='deprecation-banner-text'>
        Pengembangan SIMRS V1 akan berakhir pada akhir September 2026. Silakan
        beralih ke NUHA V3 untuk mendapatkan fitur dan update terbaru.
      </p>
      <IconButton
        aria-label='Tutup pemberitahuan'
        size='small'
        className='deprecation-banner-close'
        onClick={() => setShow(false)}>
        <CloseIcon fontSize='inherit' />
      </IconButton>
    </div>
  );
}

export default WrapperDeprecationBanner;
